import { useEmbedAPI } from '#cutils/hooks/useEmbedAPI';
import type { EmbedTeaser } from '#domains/resolver/board-section-data';

import styles from './BoardSectionItemEmbed.module.scss';

type Props = {
	teaser: EmbedTeaser;
	isLarge?: boolean;
};

export function BoardSectionItemEmbed({ teaser: { url, rowId, altText, boardSectionItemId, boardId }, isLarge }: Props) {
	const { height, isInitialized, isEmbedInitialized, iframeRef } = useEmbedAPI(url, `${rowId}_${boardSectionItemId}`, {
		type: 'overview',
		id: boardId,
	});

	const urlWithSectionId = new URL(url);
	urlWithSectionId.searchParams.append('viewId', boardSectionItemId.toString());

	return (
		<article className={`${styles.wrapper} ${isLarge ? styles.large : ''}`}>
			{isInitialized && (
				<iframe
					ref={iframeRef}
					frameBorder="0"
					className={`${styles.iframe} ${isEmbedInitialized ? styles.initialized : ''}`}
					style={{ height: height == undefined ? undefined : `${height}px` }}
					key={rowId}
					src={urlWithSectionId.toString()}
					title={altText || 'Embed'}
					tabIndex={-1}
				/>
			)}
		</article>
	);
}
